<template>
  <div class="scroll-nav-container">
    <v-btn @click="e => $emit('click:search')" class="mb-1" :class="{'d-block': $vuetify.breakpoint.smAndUp}" key="7" icon color="grey" :large="$vuetify.breakpoint.xs" :x-large="$vuetify.breakpoint.smAndUp">
      <v-icon >mdi-magnify</v-icon>
    </v-btn>
    <transition-group name="slide" class="">
      <v-btn @click="e => $emit('click:urgent')" :class="{'d-block': $vuetify.breakpoint.smAndUp}" key="1" icon color="error" :large="$vuetify.breakpoint.xs" :x-large="$vuetify.breakpoint.smAndUp">
        <v-badge class="small_bg" overlap bordered left v-bind="args_by_status('NEW')">
          <v-icon >mdi-file-document-alert</v-icon>
        </v-badge>
      </v-btn>
      <v-btn @click="e => $emit('click:cooking')" :class="{'d-block': $vuetify.breakpoint.smAndUp}" key="3" icon color="primary" :large="$vuetify.breakpoint.xs" :x-large="$vuetify.breakpoint.smAndUp">
        <v-badge class="small_bg" overlap bordered left v-bind="args_by_status('COOKING')">
          <v-icon >mdi-chef-hat</v-icon>
        </v-badge> 
      </v-btn>
      <v-btn @click="e => $emit('click:delivery')" :class="{'d-block': $vuetify.breakpoint.smAndUp}" key="4" icon color="blue" :large="$vuetify.breakpoint.xs" :x-large="$vuetify.breakpoint.smAndUp">
        <v-badge class="small_bg" overlap bordered left v-bind="args_by_status('DELIVERING')">
          <v-icon >mdi-run-fast</v-icon>
        </v-badge> 
      </v-btn>
      <v-btn @click="e => $emit('click:archive')" :class="{'d-block': $vuetify.breakpoint.smAndUp}" key="5" icon color="grey" :large="$vuetify.breakpoint.xs" :x-large="$vuetify.breakpoint.smAndUp">
        <v-badge class="small_bg" overlap bordered left v-bind="args_by_status('ARCHIVED')">
          <v-icon >mdi-package-down</v-icon>
        </v-badge> 
      </v-btn>
      <v-btn @click="e => $emit('click:awaiting')" :class="{'d-block': $vuetify.breakpoint.smAndUp}" key="2" icon color="orange" :large="$vuetify.breakpoint.xs" :x-large="$vuetify.breakpoint.smAndUp">
        <v-badge class="small_bg" overlap bordered left v-bind="args_by_status('DELAYED')" >
          <v-icon >mdi-clock</v-icon>
        </v-badge> 
      </v-btn>
      <v-btn @click="e => $emit('click:deleted')" :class="{'d-block': $vuetify.breakpoint.smAndUp}" key="6" icon color="grey-darken-5" :large="$vuetify.breakpoint.xs" :x-large="$vuetify.breakpoint.smAndUp">
        <v-badge class="small_bg" overlap bordered left v-bind="args_by_status('CANCELED')">
          <v-icon >mdi-delete-forever</v-icon>
        </v-badge> 
      </v-btn>
    </transition-group>
    <!-- <v-spacer></v-spacer> -->
  </div>
</template>

<script>
import {OrderStatus} from '../../helpers/status_helper.js'

export default{
  data: ()=>({
    status: OrderStatus
  }),
  methods: {
    args_by_status(status){
      let content = status in this.$store.getters.ordersByStatus ? this.$store.getters.ordersByStatus[status].length : 0
      let value = content > 0

      return {
        content: this.bound(content),
        value,
        color: this.status[status].color
      }
    },
    bound(v) {
      return v >= 100 ? '99+' : v
    }
  },
  
}
</script>

<style scoped>
.scroll-nav-container {
  position: relative; 
  top: 0; 
  flex-shrink: 1; 
  display: flex; 
  justify-content: space-between; 
  padding: 5px;
  flex-wrap: nowrap;
}

.small_bg{
  padding: 0px;
}

</style>

<style>
.v-badge__badge{
  padding: 3px 4px;
  height: 15px;
  min-width: 15px;
  font-size: 10px;
} 


</style>